import React, { Component } from 'react';
import classNames from 'classnames'

export default class Header extends Component {
  render() {
    const { className, ...props } = this.props;

    return (
      <header className={classNames('App-header', className)} { ...props }>
        <div className="container">
          <div className="col-xs-12 col-lg-10 col-lg-push-1">
            <h1>{this.props.children}
              <hr/>
            </h1>
          </div>
        </div>
      </header >
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Header.js